/*
 * @Author: wangbaihe
 * @Date: 2023-04-03 10:51:12
 * @LastEditors: wangbaihe
 * @LastEditTime: 2023-08-01 14:45:37
 * @FilePath: \common-mediax\src\apis\MediaCloudArticleAudit\Config.js
 * @Description:
 */
import { createAPI } from '@common'

export default {
  getFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0f60benjo0epn0gpmefs', 'get', config),
  // 获取根节点
  getRoot: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs0sppu', 'get', config),
  // 获取子节点
  getSubs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0f60benjo0epn0gpmefst', 'get', config),
  // 查询文件夹信息
  getFolder: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs', 'get', config),
  // 新增文件夹
  postFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0f60benjo0epn0gpmefst', 'post', config),
  // 修改文件夹
  putFolder: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs', 'put', config),
  // 删除文件夹
  deleteFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0f60benjo0epn0gpmefst', 'delete', config),
  // 获取平行审核操作列表
  getOperations: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0dpogjh0pqfsbujpot', 'get', config),
  // 设置平行审核操作
  postOperations: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0dpogjh0tbwfPqfsbujpo', 'post', config),
  // 获取机构角色列表
  getUsers: (config) => createAPI('customEncryptApiName-1/0f60benjo0psht0mjtu', 'get', config)
}
